import RawTour from "@/RawTour";
import MockTours from "@/mock/tours.json"
import countries from "@/data/contries.json";
import axios from "axios";

const BASE_URL = process.env.NODE_ENV === "development" ? "https://travel.netwiz.ru" : "";

export type SearchParams = {
    from:string,
    to:string,
    start_date:Date,
    nights_count: number,
    adults_count: number
}

export async function index(from_city:string,to_country:string,start_date: Date,nights: number,adults_count: number): Promise<{[key:string]: RawTour[]}>{

    // if(process.env.NODE_ENV === "development"){
    //     return MockTours as unknown as {[key:string]: RawTour[]};
    // }

    const from_city_object = countries.find(item=> item.label === from_city);
    const to_city_object = countries.find(item=> item.label === to_country);

    if(!from_city_object || !to_city_object){
        return {};
    }

    const dateTour = `${start_date.getDate()}.${start_date.getMonth() + 1}.${start_date.getFullYear()}-${start_date.getDate()}.${start_date.getMonth() + 1}.${start_date.getFullYear()}`;

    const params = new URLSearchParams([
        ["AJAX","Y"],
        ["selectCityFrom", from_city_object.label],
        ["selectCityFromHide", from_city_object.to_city.toString()],
        ["selectCityTo", to_city_object.label],
        ["selectCityToHide", to_city_object.to_city.toString()],
        ["selectCountryTo", to_city_object.to_country.toString()],
        ["selectCountryToName", to_city_object.label ],
        ["dateTour", dateTour],
        ["dateTourDay", `${start_date.getDate()}.${start_date.getMonth()+1}`],
        ["night", nights.toString()],
        ["adults", adults_count.toString()],
    ])
    return (await axios.get(BASE_URL + `/tours/beach-tours/?`+params.toString())).data;
}